import { metaAdapter } from '@/adapters/meta';

export const articleAdapter = (data) => {
  return {
    id: data.id,
    type: data.type,
    title: data.title,
    link: data.link,
    publishedAt: data.published_at,
    text: data.text,
  };
};
export const articlesAdapter = ({ data, meta }) => {
  return {
    articles: data.map(articleAdapter),
    meta: metaAdapter(meta),
  };
};
